import React from "react";
import about from "../../assets/About.png";
import vision from "../../assets/Vision.png";
import mission from "../../assets/Mission.png";
import overview from "../../assets/overview1.png";
import CompanyLogo from "../../common/CompanyLogo";
const About = () => {
  return (
    <div className="w-full">
      <CompanyLogo title={"About Us"} subtitle={"About"} />
      <div className="w-full max-w-[1250px]     mx-auto">
        <section className="md:mt-10">
          <h1 className="text-3xl font-semibold p-2">
            About <span className="text-primaryColor">FranchiseBX</span>
            <hr className="md:mt-4" />
          </h1>

          <div className="w-full h-full flex lg:flex-row flex-col justify-between items-center gap-5 p-2">
            <div className="space-y-5 w-full lg:w-[60%]">
              <p>
                Welcome to FranchiseBX, the premier platform dedicated to
                connecting aspiring entrepreneurs with a diverse array of
                franchise opportunities. At FranchiseBX, we understand the
                complexities and challenges of finding the right business
                venture. That’s why we’ve created a comprehensive platform that
                simplifies the process, making it easier for you to find and
                secure the perfect franchise that aligns with your goals and
                aspirations.
              </p>
              <div className="flex justify-start items-center gap-4">
                <div className="w-20 h-20 rounded-full bg-primaryColor p-4">
                  <img src={mission} alt="mission" />
                </div>
                <div className="w-3/4">
                  <p className="font-semibold">Mission</p>
                  <p>
                    Our mission is to empower individuals by providing access to
                    a wide range of franchise opportunities from various
                    industries.
                  </p>
                </div>
              </div>
              <div className="flex justify-start items-center gap-4">
                <div className="w-20 h-20 rounded-full bg-orangeColor p-4">
                  <img src={vision} alt="vision" />
                </div>
                <div className="w-3/4">
                  <p className="font-semibold">Vision</p>
                  <p>
                    Our mission is to empower individuals by providing access to
                    a wide range of franchise opportunities from various
                    industries.
                  </p>
                </div>
              </div>
            </div>
            <div>
              <img
                src={about}
                alt="About_Image"
                className="rounded-md w-[500px] h-[400px]"
              />
            </div>
          </div>
        </section>
        <section className="mt-10">
          <div>
            <p className="text-3xl font-semibold text-center">
              What We <span className="text-primaryColor">Offer</span>
            </p>
            <hr className="mt-5" />
          </div>
          <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 mb-5">
            <div>
              <div className="w-8 h-8 rounded-md p-2 bg-[#F5FDE6] border border-[#A2CE4C] mx-auto">
                <img src={overview} alt="Overview" />
              </div>
              <p className="text-[#222222] font-semibold text-center">
                Diverse Franchise Listings
              </p>
              <p className="text-subtext_color text-sm text-center">
                Our platform features an extensive catalog of franchises from
                different sectors.
              </p>
            </div>
            <div>
              <div className="w-8 h-8 rounded-md p-2 bg-[#FFFBEE] border border-orangeColor mx-auto">
                <img src={overview} alt="Overview" />
              </div>
              <p className="text-[#222222] font-semibold text-center">
                Diverse Franchise Listings
              </p>
              <p className="text-subtext_color text-sm text-center">
                Our platform features an extensive catalog of franchises from
                different sectors.
              </p>
            </div>
            <div>
              <div className="w-8 h-8 rounded-md p-2 bg-[#EBF0EE] border border-text_color mx-auto">
                <img src={overview} alt="Overview" />
              </div>
              <p className="text-[#222222] font-semibold text-center">
                Diverse Franchise Listings
              </p>
              <p className="text-subtext_color text-sm text-center">
                Our platform features an extensive catalog of franchises from
                different sectors.
              </p>
            </div>
            <div>
              <div className="w-8 h-8 rounded-md p-2 bg-[#F5FDE6] border border-[#A2CE4C] mx-auto">
                <img src={overview} alt="Overview" />
              </div>
              <p className="text-[#222222] font-semibold text-center">
                Diverse Franchise Listings
              </p>
              <p className="text-subtext_color text-sm text-center">
                Our platform features an extensive catalog of franchises from
                different sectors.
              </p>
            </div>
            <div>
              <div className="w-8 h-8 rounded-md p-2 bg-[#F5FDE6] border border-[#A2CE4C] mx-auto">
                <img src={overview} alt="Overview" />
              </div>
              <p className="text-[#222222] font-semibold text-center">
                Diverse Franchise Listings
              </p>
              <p className="text-subtext_color text-sm text-center">
                Our platform features an extensive catalog of franchises from
                different sectors.
              </p>
            </div>
            <div>
              <div className="w-8 h-8 rounded-md p-2 bg-[#F5FDE6] border border-[#A2CE4C] mx-auto">
                <img src={overview} alt="Overview" />
              </div>
              <p className="text-[#222222] font-semibold text-center">
                Diverse Franchise Listings
              </p>
              <p className="text-subtext_color text-sm text-center">
                Our platform features an extensive catalog of franchises from
                different sectors.
              </p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
